<template>
  <div class="landing-page">
    <!-- 导航栏：完全按参考图 - Logo 图标+文字、链接+竖线分隔、橙红 CTA -->
    <header class="landing-header">
      <div class="header-inner">
        <a href="#" class="header-brand" @click.prevent="scrollToSection('hero')">
          <img :src="require('@/assets/image/common/tool-bar-logo.png')" alt="" class="header-logo-icon">
          <span class="header-logo-text"><span class="header-logo-bold">MYTEC</span><span class="header-logo-light"></span></span>
        </a>
        <nav class="header-nav">
          <a href="#features" class="header-link" @click.prevent="scrollToSection('features')">AI Personalization</a>
          <span class="header-sep" aria-hidden="true" />
          <router-link to="/about" class="header-link">About</router-link>
        </nav>
        <div class="header-cta">
          <button type="button" class="btn btn-cta-nav ripple-btn" @click="ripple($event); $router.push('/loginNew')">
            Start Free Trial
          </button>
        </div>
      </div>
    </header>

    <!-- AI 特性：胶囊标签 + 标题描述 + 卡片 -->
    <section id="features" class="section section-ai">
      <span class="section-badge-pill">AI Technology Driven</span>
      <h3 class="section-title">Intelligently Adapts to Every Student's Learning Pace</h3>
      <p class="section-desc">Through AI algorithms analyzing learning data, we create a customized learning path for each student</p>
      <div class="feature-grid">
        <div
            v-for="(item, i) in features"
            :key="i"
            class="feature-card card-hover"
        >
          <div class="feature-icon-wrap" :class="'feature-icon-' + item.iconColor">
            <svg v-if="item.icon === 'brain'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-10A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-10A2.5 2.5 0 0 0 14.5 2Z"/></svg>
            <svg v-else-if="item.icon === 'lightbulb'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.8 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>
            <svg v-else-if="item.icon === 'chat'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            <svg v-else-if="item.icon === 'chart'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          </div>
          <h4 class="feature-title">{{ item.title }}</h4>
          <p class="feature-desc">{{ item.desc }}</p>
          <a href="#" class="feature-link ripple-btn" @click.prevent="ripple1( i)">Learn More <span aria-hidden="true">→</span></a>
        </div>
      </div>
    </section>

    <!-- 页脚：与参考图完全一致 - 三列 + 底栏 -->
    <footer class="landing-footer">
      <div class="footer-inner">
        <div class="footer-main">
          <div class="footer-col footer-col-brand">
            <div class="footer-logo">MYTutor <span class="footer-logo-accent">Math</span></div>
            <p class="footer-desc">Empowering K-12 students with AI-powered personalized math learning. Our platform adapts to each student's unique learning style and pace, making mathematics accessible and enjoyable for everyone.</p>
            <div class="footer-social">
              <a href="#" class="footer-social-icon" aria-label="Facebook" @click.prevent="ripple($event)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg></a>
              <a href="#" class="footer-social-icon" aria-label="Twitter" @click.prevent="ripple($event)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg></a>
              <a href="#" class="footer-social-icon" aria-label="Instagram" @click.prevent="ripple($event)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg></a>
              <a href="#" class="footer-social-icon" aria-label="YouTube" @click.prevent="ripple($event)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="currentColor"/></svg></a>
            </div>
          </div>
          <div class="footer-col footer-col-contact">
            <h3 class="footer-label">CONTACT ADDRESS</h3>
            <p class="footer-contact-line">1739 Southmere Crescent Surrey</p>
            <p class="footer-contact-line">BC Canada V4A7A8</p>
            <h3 class="footer-label">CONTACT PHONE</h3>
            <p class="footer-contact-line"><a href="tel:+16043515688" class="footer-link ripple-btn" @click="ripple($event)">+16043515688</a></p>
            <h3 class="footer-label">EMAIL ADDRESS</h3>
            <p class="footer-contact-line"><a href="mailto:info@mytec-edu.com" class="footer-link ripple-btn" @click="ripple($event)">info@mytec-edu.com</a></p>
          </div>
          <div class="footer-col footer-col-img">
            <div class="footer-img-wrap">
              <img src="/static/landing/footer-student.jpg" alt="Student learning" class="footer-img" data-fallback="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&q=80" @error="onImgError($event)" />
            </div>
          </div>
        </div>
        <div class="footer-bar">
          <span class="footer-copy">© 2026 MYTutor Math. All rights reserved.</span>
          <div class="footer-legal">
            <a href="#" class="footer-legal-link ripple-btn" @click.prevent="ripple($event)">Privacy Policy</a>
            <a href="#" class="footer-legal-link ripple-btn" @click.prevent="ripple($event)">Terms of Service</a>
            <a href="#" class="footer-legal-link ripple-btn" @click.prevent="ripple($event)">Help Center</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- 全局涟漪（固定定位，点击时显示） -->
    <span v-show="rippleVisible" class="ripple ripple-fixed" :style="rippleStyle" />
    <el-dialog
        class="dialog"
        :visible.sync="dialogVisible"
        width="30%">
      <div
          class="feature-card card-hover"
      >
        <div class="feature-icon-wrap" :class="'feature-icon-' + features[this.index].iconColor">
          <svg v-if="features[this.index].icon === 'brain'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-10A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-10A2.5 2.5 0 0 0 14.5 2Z"/></svg>
          <svg v-else-if="features[this.index].icon === 'lightbulb'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.8 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>
          <svg v-else-if="features[this.index].icon === 'chat'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <svg v-else-if="features[this.index].icon === 'chart'" class="feature-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        </div>
        <h4 class="feature-title">{{ features[this.index].title }}</h4>
        <p class="feature-desc">{{ features[this.index].desc }}</p>
        <div v-html="this.dialogList[this.index]?.label" class="feature-desc">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Landing',
  data () {
    return {
      form: {
        fullName: '',
        email: '',
        phone: '',
        grade: '',
        message: ''
      },
      rippleVisible: false,
      rippleStyle: {},
      imageFallbacks: {
        hero: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&q=80',
        avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80'
      },
      features: [
        { title: 'Teacher Tools', desc: 'MYTutor empowers teachers to guide students effectively.', icon: 'brain', iconColor: 'purple' },
        { title: 'Student Progress Dashboard', desc: 'Teachers track student progress via a clear dashboard.', icon: 'lightbulb', iconColor: 'blue' },
        { title: 'Performance Reports', desc: 'Detailed reports help teachers analyze student performance and target support.', icon: 'chat', iconColor: 'teal' },
        { title: 'Learning Analytics', desc: 'MYTutor’s analytics help teachers spot gaps and guide learning effectively.', icon: 'chart', iconColor: 'orange' }
      ],
      curriculum: [
        { tag: 'Elementary', title: 'Building Strong Math Foundations', desc: 'Interactive learning with games and visual aids to make math fun and engaging for young learners.', img: '/static/landing/curriculum-elementary.jpg', imgFallback: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=80', pillColor: 'lightGreen', dark: false },
        { tag: 'Middle School', title: 'Advanced Problem Solving Skills', desc: 'Comprehensive curriculum covering algebra, geometry, and critical thinking with AI-powered adaptive learning.', img: '/static/landing/curriculum-middle.jpg', imgFallback: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&q=80', pillColor: 'darkGreen', dark: true },
        { tag: 'High School', title: 'College Prep Excellence', desc: 'Advanced mathematics including calculus, statistics, and test preparation for college entrance exams.', img: '/static/landing/curriculum-high.jpg', imgFallback: 'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800&q=80', pillColor: 'lightGreen', dark: false }
      ],
      dialogVisible: false,
      index: 0,
      dialogList: [
        {
          label: 'MYTutor provides powerful tools that help teachers better understand and support their students\' learning. With clear insights and easy-to-use dashboards, teachers can monitor progress, identify challenges, and guide students more effectively.'
        },
        {
          label: 'Teachers can view each student’s learning progress in a clear and organized dashboard.\n' +
              'Track completed topics, learning activity, and overall progress to quickly understand how students are advancing through the curriculum.\n'
        },
        {
          label: 'Detailed performance reports provide insights into student achievement and learning trends.\n' +
              'Teachers can review quiz results, accuracy rates, and topic mastery to identify areas where students may need additional support.\n'
        },
        {
          label: 'MYTutor’s learning analytics highlight patterns in student learning behavior.\n' +
              'Teachers can identify knowledge gaps, track improvement over time, and make more informed decisions about how to guide each student’s learning journey.\n'
        }
      ]
    }
  },
  methods: {
    ripple1 (i) {
      this.index = i
      this.dialogVisible = true
    },
    ripple (e) {
      const size = 120
      const x = e.clientX
      const y = e.clientY
      this.rippleStyle = {
        left: `${x}px`,
        top: `${y}px`,
        width: `${size}px`,
        height: `${size}px`,
        marginLeft: `-${size / 2}px`,
        marginTop: `-${size / 2}px`
      }
      this.rippleVisible = true
      this.$nextTick(() => {
        const el = this.$el.querySelector('.ripple-fixed')
        if (el) {
          el.classList.remove('ripple-active')
          void el.offsetWidth
          el.classList.add('ripple-active')
        }
        clearTimeout(this._rippleTimer)
        this._rippleTimer = setTimeout(() => {
          this.rippleVisible = false
        }, 650)
      })
    },
    scrollToSection (id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    onImgError (e) {
      const el = e && e.target
      if (!el || el.dataset.fallbackUsed) return
      const fallback = el.dataset.fallback
      if (fallback) {
        el.dataset.fallbackUsed = '1'
        el.src = fallback
      } else {
        el.style.display = 'none'
      }
    },
    onSubmit () {
      // 可接后端
      this.$message?.success?.('Message sent! We will contact you soon.') || alert('Message sent! We will contact you soon.')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 模块样式与间距统一：同一套变量控制各区块 */
.landing-page {
  --lp-section-pad: 64px;
  --lp-gap: 24px;
  --lp-gap-sm: 12px;
  --lp-gap-lg: 40px;
  --lp-card-pad: 24px;
  --lp-radius: 12px;
  --lp-radius-sm: 8px;
  --lp-img-feature: 160px;
  --lp-img-curriculum: 180px;
  --lp-max: 1200px;
  --lp-margin-vw: 6%;
  --lp-label-size: 1rem;
  --lp-label-weight: 700;
  --lp-text-color: #333;
  --lp-text-muted: #666;
  font-family: 'Ubuntu', -apple-system, BlinkMacSystemFont, sans-serif;
  /* 背景与参考一致：顶部淡紫→中段浅灰→底部白 */
  background: linear-gradient(180deg, #f3f0ff 0%, #f9fafc 46%, #ffffff 100%);
  color: #1e293b;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

/* 全局内容宽度限制：避免在大屏上无限拉伸 */

/* 点击涟漪动画 */
@keyframes ripple-anim {
  to {
    transform: scale(2.5);
    opacity: 0;
  }
}

/* 按钮基础 */
.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  overflow: hidden;
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.btn:active {
  transform: translateY(0);
}
.btn-primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
}
.btn-outline {
  background: transparent;
  color: #2563eb;
  border: 2px solid #2563eb;
}
.btn-outline:hover {
  background: rgba(37, 99, 235, 0.08);
}
.btn-sm {
  padding: 8px 16px;
  font-size: 0.9rem;
}
.link-btn {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  font-weight: 600;
  padding: 4px 0;
  position: relative;
  overflow: hidden;
  transition: color 0.2s;
}
.link-btn:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

/* 卡片悬停 */
.card-hover {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

/* 导航栏：左右边距 6% 视口 */
.landing-header {
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 12px 0;
  background: linear-gradient(180deg, #f7f5ff 0%, #f4f0ff 60%, #f3efff 100%);
  box-shadow: none;
  width: 100%;
  box-sizing: border-box;
}
.header-inner {
  max-width: var(--lp-max);
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
}
.header-logo-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  display: block;
}
.header-logo-text {
  font-size: 1.5rem;
  letter-spacing: -0.01em;
}
.header-logo-bold {
  font-weight: 700;
  color: #020617;
}
.header-logo-light {
  font-weight: 700;
  color: #020617;
}
.header-brand:hover .header-logo-bold { color: #020617; }
.header-brand:hover .header-logo-light { color: #020617; }
.header-nav {
  display: flex;
  align-items: center;
  gap: 0;
}
.header-link {
  font-size: 16px;
  font-weight: 400;
  color: #4b5563;
  text-decoration: none;
  transition: color 0.2s;
  padding: 0 14px;
}
.header-link:hover {
  color: #111827;
}
.header-sep {
  display: none;
}
.header-cta {
  display: flex;
  align-items: center;
}
.btn-cta-nav {
  padding: 10px 22px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  background: linear-gradient(90deg, #f97316 0%, #ef4444 100%);
  transition: opacity 0.2s, transform 0.2s;
  position: relative;
  overflow: hidden;
  height: 48px;
}
.btn-cta-nav:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}
@media (max-width: 768px) {
  .header-nav { display: none; }
}

/* Hero：与各 section 统一上下间距 */
.hero {
  text-align: center;
  width: 100%;
  padding: var(--lp-section-pad) 0;
  position: relative;
  min-height: 320px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}
.hero-with-bg .hero-bg-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  border-radius: 0 0 var(--lp-radius) var(--lp-radius);
}
.hero-bg-wrap::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* 截图是更“整块”的淡紫背景 */
  background: rgba(243, 240, 255, 0.96);
}
.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.06; /* 只保留极弱纹理 */
}
.hero-with-bg .hero-pretitle,
.hero-with-bg .hero-title,
.hero-with-bg .hero-subtitle,
.hero-with-bg .hero-cta,
.hero-with-bg .hero-devices {
  position: relative;
  z-index: 1;
}
.hero-pretitle {
  font-size: 1.125rem;
  font-weight: 500;
  color: #475569;
  margin: 0 0 var(--lp-gap-sm) 0;
  line-height: 1.5;
}
.hero-title {
  font-size: 3.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 var(--lp-gap-sm) 0;
  line-height: 1.2;
}
.hero-subtitle {
  font-size: 24px;
  font-weight: 300;
  color: rgb(75, 85, 99);
  margin: 0 0 var(--lp-gap) 0;
  line-height: 1.5;
}
.hero-cta {
  display: flex;
  gap: var(--lp-gap);
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: var(--lp-gap-lg);
}
.btn-hero-primary {
  line-height: 24px;
  padding: 16px 40px;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  background: linear-gradient(90deg, #8b5cf6 0%, #6366f1 50%, #3b82f6 100%);
  transition: opacity 0.2s, transform 0.2s;
  position: relative;
  overflow: hidden;
}
.btn-hero-primary:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}
.hero-cta-arrow {
  margin-left: 6px;
}
.btn-hero-outline {
  line-height: 24px;
  padding: 16px 40px;
  font-size: 1rem;
  font-weight: 500;
  color: #0f172a;
  border: 1px solid #334155;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  position: relative;
  overflow: hidden;
}
.btn-hero-outline:hover {
  background: rgba(15, 23, 42, 0.06);
}
/* 设备模拟图：左平板、中竖板、右笔记本 */
/* 设备模拟图：左平板、中竖板、右笔记本 */
.hero-devices {
  display: flex;
  justify-content: center;
  align-items: center; /* 真正垂直居中 */
  gap: 2%;
  max-width: 1040px;
  margin: 0 auto;
  position: relative;
  min-height: 380px;
}

.hero-device {
  flex: 0 0 auto;
  display: flex;
  align-items: center; /* 这里必须改成 center，不是 flex-end！ */
  justify-content: center;
}

.hero-device-left {
  z-index: 1;
  flex: 0 0 28%;
  /* transform: translateY(12%);  注释掉，否则永远不居中 */
}

.hero-device-center {
  z-index: 2;
  flex: 0 0 34%;
  margin: 0;
}

.hero-device-right {
  z-index: 1;
  flex: 0 0 28%;
  /* transform: translateY(12%);  注释掉 */
}
.hero-device-card {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
  background: #fff;
}
.hero-device-card-light {
  padding: 0;
  background: #9b87ff;
}
.hero-device-card-dark {
  background: linear-gradient(180deg, #5b2a86 0%, #0b1220 100%);
}
.hero-device-card-laptop {
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
}
.hero-device-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero-device-inset {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.hero-device-inset-tablet {
  background: transparent;
}
.hero-device-img-contain {
  height: auto;
  max-height: 86%;
  object-fit: contain;
  background: #0b1220;
  border-radius: 16px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.22);
}
//.hero-device-left .hero-device-card,
//.hero-device-right .hero-device-card {
//  width: 80%;
//}
.hero-device-center .hero-device-card {
  width: 100%;
}
.hero-device-right .hero-device-card {
  background: #fff;
}
.hero-laptop-screen {
  flex: 1;
  min-height: 0;
  background: #0b1220;
}
.hero-laptop-screen .hero-device-img {
  object-fit: cover;
}
.hero-laptop-base {
  display: none;
}
@media (max-width: 768px) {
  .hero-devices {
    min-height: 260px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .hero-device-left,
  .hero-device-right {
    flex: 0 0 40%;
    transform: none;
  }
  .hero-device-center {
    flex: 0 0 80%;
    margin: 0;
  }
  .hero-device-left .hero-device-card,
  .hero-device-right .hero-device-card {
    width: 100%;
    height: auto;
  }
  .hero-device-center .hero-device-card {
    width: 100%;
    height: auto;
  }
}

/* Section 通用：左右边距 6% 视口，内容区 88% */
.section {
  width: 100%;
  padding: 6rem 3rem;
  box-sizing: border-box;
}
.section-badge {
  font-size: 0.75rem;
  color: #2563eb;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--lp-gap-sm);
}
.section-badge-pill {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  color: #9133ae;
  background: #f7edfc;
  padding: 0.5rem 1.5rem;
  border-radius: 999px;
  margin-bottom: var(--lp-gap-sm);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 24px;
}
.section-title {
  font-size: 3rem ;
  font-weight: var(--lp-label-weight);
  color: var(--lp-text-color);
  margin-bottom: var(--lp-gap-sm);
  line-height: 1.3;
}
.section-ai .section-title {
  color: #2f3133;
}
.section-subtitle {
  font-size: 1.125rem;
  color: var(--lp-text-muted);
  margin-bottom: var(--lp-gap-sm);
}
.section-desc {
  font-size:1.25rem;
  color: var(--lp-text-muted);
  line-height: 1.6;
  margin-bottom: var(--lp-gap);
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}
.section-ai {
  text-align: center;
}
.section-ai .section-desc {
  color: rgb(75 85 99);
  font-weight: 400;
  margin-bottom: var(--lp-gap);
}
.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--lp-gap);
  margin: 0 auto;
  max-width: 80rem;
}
.feature-card {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: left;
  border: none;
}
.feature-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}
.feature-icon-svg {
  width: 24px;
  height: 24px;
  color: #fff;
}
.feature-icon-purple {
  background: #8b5cf6;
}
.feature-icon-blue {
  background: #3b82f6;
}
.feature-icon-teal {
  background: #14b8a6;
}
.feature-icon-orange {
  background: #f97316;
}
.feature-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2f3133;
  margin-bottom: 1rem;
  line-height: 2rem;
}
.feature-desc {
  font-size: 1.125rem;
  color: #64748b;
  line-height: 1.625rem;
  margin-bottom: 1.5rem;
  font-weight: 400;
  white-space: normal;
  overflow-wrap: normal;
  word-break: normal;
  hyphens: none;
}
.feature-link {
  font-size: 1.125rem;
  font-weight: 600;
  color: #7c3aed;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.feature-link:hover {
  color: #6d28d9;
  text-decoration: underline;
}
@media (max-width: 1024px) {
  .feature-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 560px) {
  .feature-grid { grid-template-columns: 1fr; }
}

/* Curriculum：标题字体/颜色/排版与上间距统一 */
.section-curriculum {
  background: #fff;
}
.section-curriculum-div{
  max-width: 80rem;
  margin: 0 auto;
}
.curriculum-header {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.9fr);
  column-gap: 72px;
  align-items: start;
  margin-bottom: 40px;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.curriculum-header-left {
  min-width: 0;
}
.curriculum-label {
  font-size: 2.25rem;
  color: #9ca3af;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  line-height: 2.5rem;
  letter-spacing: 0.03em;
  text-transform: none;
}
.curriculum-main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 3rem;
  white-space: nowrap;
}
.curriculum-main-title em {
  font-style: italic;
  font-weight: 700;
  color: #111827;
}
.curriculum-overview {
  font-size: 1.125rem;
  color: #6b7280;
  line-height: 1.625rem;
  margin: 0;
  padding-top: 0.6em;
  max-width: 500px;
  margin-left: auto;
}
.curriculum-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--lp-gap);
  max-width: 100%;
  min-width: 0;
}
.curriculum-card {
  background: #fff;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: left;
  min-width: 0;
}
.curriculum-card-dark {
  background: #232323;
}
.curriculum-img-wrap {
  flex: 0 0 auto;
  width: 100%;
  min-height: 180px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background: #f1f5f9;
}
.curriculum-img {
  width: 100%;
  height: 100%;
  min-height: 180px;
  object-fit: cover;
  display: block;
}
/* 卡片内上间距统一：标签/标题/描述/按钮之间同一间距 */
.curriculum-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 var(--lp-card-pad) var(--lp-card-pad);
  padding-top: 0;
}
.curriculum-pill {
  margin-top: calc(-1 * var(--lp-gap));
  margin-bottom: var(--lp-gap-sm);
  align-self: flex-start;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 999px;
  position: relative;
  z-index: 1;
}
.curriculum-pill-lightGreen {
  background: #b7ec69;
  color: #fff;
}
.curriculum-pill-darkGreen {
  background: #339900;
  color: #fff;
}
.curriculum-card-body .curriculum-title {
  margin: 0 0 var(--lp-gap-sm) 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.3;
}
.curriculum-card-body .curriculum-desc {
  margin: 0 0 var(--lp-gap-sm) 0;
  flex: 1;
  font-size: 0.9375rem;
  line-height: 1.5;
}
.curriculum-card-body .curriculum-btn {
  margin: 0;
  align-self: flex-start;
}
.curriculum-title {
  color: #232323;
}
.curriculum-card-dark .curriculum-title {
  color: #fff;
}
.curriculum-desc {
  color: #6f767e;
}
.curriculum-card-dark .curriculum-desc {
  color: rgba(255, 255, 255, 0.85);
}
/* 三张卡按钮样式一致：白底、黑边、黑字 */
.curriculum-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 500;
  background: #fff;
  color: #232323;
  border: 1px solid #232323;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.curriculum-btn:hover {
  background: #f1f5f9;
}
.curriculum-btn-dark {
  background: #fff;
  color: #232323;
  border: 1px solid #232323;
}
.curriculum-btn-dark:hover {
  background: #f1f5f9;
  color: #232323;
}
@media (max-width: 900px) {
  .curriculum-header {
    grid-template-columns: 1fr;
    gap: var(--lp-gap-sm);
  }
  .curriculum-grid { grid-template-columns: 1fr; }
}

/* Testimonial：左右由 .section 控制 */
.section-testimonial {
  background: #f0f9ff;
}
.testimonial-wrap {
  display: flex;
  min-height: 380px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  background: #fff;
  max-width: 80rem;
  margin: 0 auto;
  height: 600px;
}
.testimonial-img-col {
  min-height: 320px;
  overflow: hidden;
  flex-shrink: 0;
}
.testimonial-photo {
  width: 100%;
  height: 100%;
  min-height: 320px;
  object-fit: cover;
  display: block;
}
.testimonial-text-col {
  background: #000;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.testimonial-quote {
  font-size: 4rem;
  font-weight: var(--lp-label-weight);
  line-height: 1;
  color: #f59e0b;
  margin-bottom: 2rem;
  font-family: Georgia, serif;
}
.testimonial-text {
  font-size: 1.5rem;
  line-height: 1.75;
  color: #fff;
  margin: 0 0 2.5rem 0;
}
.testimonial-author {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: var(--lp-label-weight);
  color: #fff;
  margin: 0 0 var(--lp-gap-sm) 0;
}
.testimonial-role {
  font-size: 1rem;
  line-height: 1.5rem;
  color: #ccc;
  margin: 0 0 var(--lp-gap) 0;
}
.testimonial-btn {
  align-self: flex-start;
  padding: 12px 24px;
  border: none;
  border-radius: 999px;
  font-size: 0.9375rem;
  font-weight: 600;
  color: rgb(17, 24, 39);
  background: rgb(255, 184, 198);
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}
.testimonial-btn:hover {
  color: rgb(17, 24, 39);
  background: rgb(255, 159, 180);
  transform: translateY(-1px);
}
@media (max-width: 700px) {
  .testimonial-wrap {
    grid-template-columns: 1fr;
    min-height: auto;
  }
  .testimonial-img-col {
    min-height: 260px;
  }
  .testimonial-photo {
    min-height: 260px;
  }
  .testimonial-text-col {
    padding: 32px 24px 28px;
  }
}

/* Get Started Today：与各 section 统一上下间距和模块间距 */
.section-get-started {
  background: linear-gradient(to right, #f5f3ff 0%, #fafafa 50%, #fff 100%);
  width: 100%;
  padding: 3rem 6rem;
  box-sizing: border-box;
  .get-started{
    max-width: 80rem;
    margin-left: auto;
    margin-right: auto;
  }
}
.get-started-title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: var(--lp-label-weight);
  color: var(--lp-text-color);
  text-align: center;
  margin: 0 0 var(--lp-gap-sm) 0;
}
.get-started-desc {
  font-size: 1rem;
  color: var(--lp-text-muted);
  text-align: center;
  margin: 0 auto var(--lp-gap) auto;
  max-width: 560px;
  line-height: 1.5;
}
.get-started-grid {
  max-width: 100%;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(2 * var(--lp-gap));
  align-items: start;
}
.get-started-form {
  display: flex;
  flex-direction: column;
  gap: var(--lp-gap);
}
.form-field {
  display: flex;
  flex-direction: column;
  gap: var(--lp-gap-sm);
}
.form-label {
  font-size: var(--lp-label-size);
  font-weight: var(--lp-label-weight);
  color: var(--lp-text-color);
}
.get-started-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.9375rem;
  background: #fff;
  font-family: inherit;
  transition: border-color 0.2s;
}
.get-started-input::placeholder {
  color: #999;
}
.get-started-input:focus {
  outline: none;
  border-color: #8b5cf6;
}
.get-started-select {
  cursor: pointer;
  appearance: auto;
}
.get-started-textarea {
  resize: vertical;
  min-height: 100px;
}
.get-started-char {
  font-size: 0.75rem;
  color: #999;
  margin-top: 4px;
}
.btn-get-started {
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(to right, #8b5cf6 0%, #6366f1 50%, #3b82f6 100%);
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
  margin-top: 4px;
}
.btn-get-started:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

/* 右侧联系信息块：与表单统一间距 */
.get-started-info {
  display: flex;
  flex-direction: column;
  gap: var(--lp-gap);
}
.info-block {
  display: flex;
  align-items: flex-start;
  gap: var(--lp-gap-sm);
}
.info-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-icon svg {
  width: 22px;
  height: 22px;
}
.info-icon-purple {
  border-color: #8b5cf6;
  color: #8b5cf6;
}
.info-icon-blue {
  border-color: #3b82f6;
  color: #3b82f6;
}
.info-icon-teal {
  border-color: #14b8a6;
  color: #14b8a6;
}
.info-content {
  flex: 1;
  min-width: 0;
}
.info-heading {
  font-size: var(--lp-label-size);
  font-weight: var(--lp-label-weight);
  color: var(--lp-text-color);
  margin: 0 0 var(--lp-gap-sm) 0;
}
.info-text {
  font-size: 0.9375rem;
  color: var(--lp-text-muted);
  margin: 0;
  line-height: 1.5;
}
.info-sub {
  font-size: 0.8125rem;
  color: #999;
  margin: var(--lp-gap-sm) 0 0 0;
}
.info-link {
  color: #666;
  text-decoration: none;
}
.info-link:hover {
  color: #333;
}
.info-block-follow {
  flex-direction: column;
  gap: var(--lp-gap-sm);
}
.info-block-follow .info-heading {
  margin-bottom: 0;
}
.info-social {
  display: flex;
  gap: var(--lp-gap-sm);
}
.info-social-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #333;
  background: #fff;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
}
.info-social-icon:hover {
  background: #333;
  color: #fff;
}
.info-social-icon svg {
  width: 18px;
  height: 18px;
}

@media (max-width: 900px) {
  .get-started-grid {
    grid-template-columns: 1fr;
    gap: calc(var(--lp-gap) + var(--lp-gap-sm));
  }
}

/* 页脚：左右边距 6% 视口 */
.landing-footer {
  background: #101010;
  color: #fff;
  width: 100%;
  padding: calc(var(--lp-section-pad) * 0.875) 0 0;
  margin-top: 0;
  box-sizing: border-box;
}
.footer-inner {
  max-width: var(--lp-max);
  margin: 0 auto;
  width: 100%;
}
.footer-main {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--lp-gap-lg);
  padding-bottom: var(--lp-gap);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  align-items: start;
}
.footer-col-brand {
  max-width: 320px;
}
.footer-logo {
  font-size: 1.5rem;
  font-weight: var(--lp-label-weight);
  color: #fff;
  margin-bottom: var(--lp-gap-sm);
  letter-spacing: -0.02em;
}
.footer-logo-accent {
  font-weight: var(--lp-label-weight);
}
.footer-desc {
  font-size: 0.9375rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 var(--lp-gap) 0;
}
.footer-social {
  display: flex;
  gap: var(--lp-gap-sm);
  align-items: center;
}
.footer-social-icon {
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.2s, border-color 0.2s;
}
.footer-social-icon:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #fff;
}
.footer-social-icon svg {
  width: 18px;
  height: 18px;
}
.footer-col-contact .footer-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.95);
  margin: 0 0 var(--lp-gap-sm) 0;
  text-transform: uppercase;
}
.footer-col-contact .footer-label:not(:first-child) {
  margin-top: var(--lp-gap);
}
.footer-contact-line {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 4px 0;
  line-height: 1.5;
}
.footer-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
}
.footer-link:hover {
  color: #fff;
}
.footer-col-img {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}
.footer-img-wrap {
  width: 100%;
  max-width: 280px;
  border-radius: var(--lp-radius);
  overflow: hidden;
  background: #1a1a1a;
}
.footer-img {
  width: 100%;
  height: 100%;
  min-height: 200px;
  object-fit: cover;
  display: block;
}
.footer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--lp-gap-sm);
  padding: var(--lp-gap) 0;
}
.footer-copy {
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.6);
}
.footer-legal {
  display: flex;
  align-items: center;
  gap: var(--lp-gap);
}
.footer-legal-link {
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.2s;
}
.footer-legal-link:hover {
  color: rgba(255, 255, 255, 0.9);
}
@media (max-width: 900px) {
  .footer-main {
    grid-template-columns: 1fr 1fr;
  }
  .footer-col-img {
    grid-column: 1 / -1;
    justify-content: center;
  }
  .footer-img-wrap {
    max-width: 100%;
  }
}
@media (max-width: 600px) {
  .footer-main {
    grid-template-columns: 1fr;
    gap: var(--lp-gap);
  }
  .footer-col-brand {
    max-width: none;
  }
  .footer-bar {
    flex-direction: column;
    text-align: center;
  }
}

/* 全局涟漪：固定定位，点击时在鼠标位置显示 */
.ripple-fixed {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  transform: scale(0);
}
.ripple-fixed.ripple-active {
  animation: ripple-anim 0.6s ease-out forwards;
}
.dialog{
  :deep .el-dialog__body{
    padding: 3rem 6rem;
  }
  :deep .el-dialog__header{
    padding: 0;
  }
  :deep .el-dialog{
    background: #fff;
    .feature-card{
      padding: 0;
    }
    .card-hover{
      transform: none;
      box-shadow:none;
    }
  }
}
</style>
<style lang="scss">
.el-dialog{
  background: rgb(246, 242, 248);
}
.dialog-view{
  padding: 2rem 6rem 3rem;
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-weight: 700;
  color: #2f3133;
}
</style>
